module.exports = __webpack_public_path__ + "media/hph-26-05_commencement.1f9d6076.webm";